module.exports = __webpack_public_path__ + "static/media/logToPng.2314e3a3.svg";